import React from "react";

export default function InstagramIcon() {
    return <svg id="social_instagram" xmlns="http://www.w3.org/2000/svg" width="26.297" height="26.297" viewBox="0 0 26.297 26.297">
    <path id="Pfad_40" data-name="Pfad 40" d="M9.574,3H22.723A6.574,6.574,0,0,1,29.3,9.574V22.723A6.574,6.574,0,0,1,22.723,29.3H9.574A6.574,6.574,0,0,1,3,22.723V9.574A6.574,6.574,0,0,1,9.574,3Z" transform="translate(-3 -3)"/>
    <circle id="Ellipse_34" data-name="Ellipse 34" cx="1.315" cy="1.315" r="1.315" transform="translate(19.285 4.383)" fill="#fff"/>
    <circle id="Ellipse_35" data-name="Ellipse 35" cx="6.136" cy="6.136" r="6.136" transform="translate(7.013 7.013)" fill="#fff"/>
  </svg>
;  
}